import React from 'react';

import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  NotificationsOff as NotificationsOffIcon,
  Smartphone as SmartphoneIcon,
  WhatsApp as WhatsAppIcon,
} from '@material-ui/icons';

interface ContactIconProps {
  type: string;
  className: string;
}

class ContactIcon extends React.PureComponent<ContactIconProps> {
  render() {
    const { type, className } = this.props;
    switch (type) {
      case 'voice':
        return <PhoneIcon className={className} />;
      case 'email':
        return <EmailIcon className={className} />;
      case 'donotcontact':
        return <NotificationsOffIcon className={className} />;
      case 'whatsapp':
        return <WhatsAppIcon className={className} />;
      // TODO use `type` as default `icon`
      default:
        return <SmartphoneIcon className={className} />;
    }
  }
}

export default ContactIcon;
